import DepositACheckPage, { getDefaultPageData, getDefaultPageUI } from "components/pages/DepositACheckPage";
import Classes, { Account } from "model";
import { BCMSStateManagerCRUD, BCMSRecord, useGlobalController } from "bcms-react";

export default function CaptureMabiDepositsCheckFrontDone(props){
    const globalController = useGlobalController();
    BCMSRecord.globalControllerFor(Classes, globalController);

    const data = BCMSStateManagerCRUD.init(getDefaultPageData())
        .update([ "deposit", "account" ], Account.firstInstanceOf())
        .update([ "deposit", "amount" ], 20)
        .submit();

    const ui = BCMSStateManagerCRUD.init(getDefaultPageUI())
        .update([ "checkFrontView", "isSet" ], true)
        .submit();

    return <DepositACheckPage data={ data } ui={ ui } />
}